var circleColor = '#ea4336';
export var circleOptions = {
  clickable: false,
  fillColor: circleColor,
  fillOpacity: 0.5,
  radius: 420,
  strokeColor: circleColor,
  strokeOpacity: 1
};